/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import { useApp } from "../../contexts";
import TabsCustom from "../../components/TabsCustom";
import { Tabs } from "antd";
import { useWindowSize } from "../../hook/useWindowSize";
import { TabEarner } from "./components/TabEarner";
import { TabEnergy } from "./components/TabEnergy";
import { TabMerchandise } from "./components/TabMerchandise";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TabSubscription } from "./components/TabSubscription";
import { ArrowDownIcon } from "../../components/Icons/ArrowDownIcon";
import { TabPrime } from "./components/TabPrime";
import { PREPOSITION } from "../Home";


export const TabAssetOption = {
  earner: "earner",
  nft_prime: "nft_prime",
  character: "character",
  energy: "energy",
  subscription: "subscription",
  merchandise: "merchandise",
};

export const Asset = () => {
  const { T, prePosition } = useApp();
  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get("type");
  const gifttype = searchParams.get("gifttype");
  const [tab, setTab] = useState(type || TabAssetOption.mall);
  const size = useWindowSize();
  const navigate = useNavigate();
  const back = () => {
    if (prePosition === PREPOSITION.HOME_ASSET) {
      navigate('/')
    }else{
      navigate(-1)
    }
  };

  const onChangeTab = (tab) => {
    if (type) {
      searchParams.delete("type");
    }
    if (gifttype) {
      searchParams.delete("gifttype");
    }
    if (type || gifttype) {
      setSearchParams(searchParams);
    }
    setTab(tab);
  };
  const clearSearchParams = (key) => {
    if (key === 'type') {
      searchParams.delete("type");
    }
    if (key === 'gifttype') {
      searchParams.delete("gifttype");
    }
    if (key) {
      setSearchParams(searchParams);
    }
  }
  useEffect(() => {
    if (prePosition && prePosition !== PREPOSITION.HOME_ASSET) {
      if (type !== 'subscription') {
        setTab(prePosition);
      };
    }
  }, [prePosition])

  useEffect(() => {
    const handlePopState = (event) => {
      if (prePosition === PREPOSITION.HOME_ASSET) {
        navigate('/')
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
  return (
    <Container>
      <ContainerView background="transparent">
      <div className="flex justify-start gap-3 items-center">
          {
            prePosition === PREPOSITION.HOME_ASSET && <div onClick={() => back()}>
            <ArrowDownIcon className="rotate-90 w-[24px] h-[24px] cursor-pointer stroke-black" />
          </div>
          }
          <TitlePage>{T("Asset")}</TitlePage>
        </div> 

        
        <TabsCustom
          spaceItem={size.width > 1024 ? 32 : 30}
          className="v2 mt-[18px] lg:mt-[34px] min-h-[calc(100vh-600px)]"
          activeKey={tab}
          onChange={(e) => onChangeTab(e)}
          destroyInactiveTabPane={true}
        >
          <Tabs.TabPane tab={T("Art")} key={TabAssetOption.earner}>
            <TabEarner type={9} />
          </Tabs.TabPane>          
          
          <Tabs.TabPane tab={T("Art Prime")} key={TabAssetOption.nft_prime}>
            <TabPrime type={14} />
          </Tabs.TabPane>

          <Tabs.TabPane tab={T("Energy")} key={TabAssetOption.energy}>
            <TabEnergy type={10} />
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={T("Subscription")}
            key={TabAssetOption.subscription}
          >
            <TabSubscription type={11} />
          </Tabs.TabPane>
          <Tabs.TabPane tab={T("Other products")} key={TabAssetOption.merchandise}>
            <TabMerchandise type={8} />
          </Tabs.TabPane>
        </TabsCustom>
      </ContainerView>
    </Container>
  );
};
